export default "__VITE_ASSET__2Mr6oV2V__"